import { Skeleton } from '@/ui/components/common/Skeleton'

/**
 * Loading placeholder for the read-mode view, mirroring its overall shape —
 * including the shell/column split, so the layout doesn't shift sideways the
 * moment the data lands.
 */
export function ReadModeSkeleton() {
  return (
    <div className="mx-auto grow w-full max-w-[100rem] bg-card px-5 py-6 sm:px-8 sm:py-8 2xl:border-x 2xl:border-border">
      <Skeleton className="h-5 w-40 mb-8" />
      <Skeleton className="h-5 w-24 mb-4" />
      <Skeleton className="h-12 w-full mb-4" />
      <Skeleton className="h-4 w-48 mb-6" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-5/6 mb-8" />
      <div className="space-y-4">
        {Array.from({ length: 3 }).map((_item, index) => (
          <Skeleton key={index} className="h-24 w-full rounded-lg" />
        ))}
      </div>
    </div>
  )
}
